<script>
    import { fly } from 'svelte/transition'
    import { apiURL } from '../../store.js'
    import Expandable from './Expandable.svelte'

    export let publication
    export let color
</script>

<div class="publication" in:fly={{ y: -20, duration: 1000 }} out:fly={{ y: 10, duration: 400 }}>
    <Expandable {color}>
        <div class="info" slot="visible">
            {#if publication.full_paper[0].type == 'Link'}
                <a
                    class="publicationTitleLink"
                    href={publication.full_paper[0].value}
                    target="_blank"
                >
                    <h2 class="title" style="color: {color};">
                        {publication.title}
                    </h2>
                </a>
            {:else if publication.full_paper[0].type == 'PDF'}
                <a
                    class="publicationTitleLink"
                    href="{apiURL}{publication.full_paper[0].value.url}"
                    target="_blank"
                >
                    <h2 class="title" style="color: {color};">
                        {publication.title}
                    </h2>
                </a>
            {/if}
            <p>{publication.authors}</p>
            <p>{publication.journal}. {publication.pubDate.toUpperCase()}. {publication.articleID}</p>
        </div>
        <div slot="label">
            <div class="revealMore">
                Reveal More
            </div>
        </div>
        <div slot="hidden">
            <div class="abstract" style="--pageColor: {color}">
                {#if publication.images.length != 0}
                    {#each publication.images as image}
                        <img src="{apiURL}{image.url}" alt={image.title} />
                    {/each}
                {/if}
                <p>{publication.abstract}</p>
                {#if publication.full_paper.length != 0}
                    {#each publication.full_paper as full_paper}
                        {#if full_paper.type == 'Link'}
                            <p class="fullPaper">
                                Full Paper:
                                <a class="fullPaperLink" target="_blank" href={full_paper.value}>
                                    Link to Journal
                                </a>
                            </p>
                        {:else if full_paper.type == 'PDF'}
                            <p class="fullPaper">
                                Full Paper:
                                <a class="fullPaperLink" target="_blank" href="{apiURL}{full_paper.value.url}">
                                    Download PDF
                                </a>
                            </p>
                        {:else}
                            <p class="fullPaper">
                                Full Paper:
                                <a class="fullPaperLink" target="_blank" href={full_paper.value.Link}>
                                    {full_paper.value.Display_Text}
                                </a>
                            </p>
                        {/if}
                    {/each}
                {/if}
                {#if publication.commentaries.length != 0}
                    <h2 class="commentaryHead">
                        Commentary:
                    </h2>
                    {#each publication.commentaries as commentary}
                        {#if typeof commentary.content !== 'string'}
                            <p class="commentary">
                                <a target="_blank" href="{apiURL}{commentary.content.url}">
                                    {commentary.citation}
                                </a>
                            </p>
                        {:else}
                            <p class="commentary">
                                <a target="_blank" href={commentary.content}>
                                    {commentary.citation}
                                </a>
                            </p>
                        {/if}
                    {/each}
                {/if}
            </div>
        </div>
    </Expandable>
</div>

<style lang="scss">
    @import "../../styles/vars";

    .publicationTitleLink:hover, .fullPaperLink:hover {
        text-decoration: none;
        cursor: pointer;
    }

    .info p:last-of-type {
        margin-bottom: 0.5rem;
    }

    .publication {
        position: relative;
        margin: 0;
        padding-bottom: 2rem;
        &::after {
            content: "";
            display: block;
            width: 200px;
            height: 2px;
            background-color: black;
            margin-top: 2rem;
        }
    }

    @include respond-to(computer) {
        .title {
            margin: 0;
            font-family: "Ysabeau";
            font-size: 1.3rem;
            line-height: 1.8rem;
            font-weight: bold;
        }

        p {
            margin: 0;
            font-family: "Ysabeau";
            font-size: 1.3rem;
            line-height: 1.8rem;

            a {
                color: black;
                font-weight: 400;
                border-bottom: 2px solid var(--pageColor);
                line-height: 1.5rem;

                &:hover {
                    text-decoration: none;
                }
            }
        }

        .revealMore {
            display: flex;
            align-items: center;
            user-select: none;
            font-family: "Work Sans";
            font-weight: 600;
            height: 1.8rem;
            text-transform: uppercase;
            letter-spacing: .05rem;
            font-size: 0.9rem;

            &:hover {
                cursor: pointer;
            }
        }

        .abstract {
            border: 2px solid transparent;
            padding: 10px 10px 1rem;
            margin-bottom: 2rem;
            border: 2px solid var(--pageColor);

            img {
                width: 90%;
                margin: 5%;
            }
        }

        .fullPaper {
            font-weight: bold;
            margin-top: 1rem;
        }

        :global(.commentaryHead) {
            font-family: "Ysabeau", serif;
            font-size: 1.3rem;
            margin-bottom: 0;
        }
    }
    @include respond-to(phone) {
        .title {
            margin: 0;
            font-family: "Ysabeau";
            font-size: 1.2rem;
            line-height: 1.6rem;
            font-weight: bold;
            margin-bottom: 0.5rem;
        }

        p {
            margin: 0;
            font-family: "Ysabeau";
            font-size: 1rem;
            line-height: 1.3rem;

            a {
                color: black;
                font-weight: 400;
                border-bottom: 2px solid var(--pageColor);
                line-height: 1.5rem;
            }
        }

        .revealMore {
            user-select: none;
            font-family: "Work Sans";
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: .05rem;
            line-height: 1.8rem;
            font-size: 0.9rem;
        }

        .abstract {
            padding: 5px 5px 1rem;
            border: 2px solid var(--pageColor);
            margin-bottom: 1rem;

            img {
                width: 90%;
                margin: 5%
            }
        }

        .fullPaper {
            font-weight: bold;
            margin-top: 1rem;
        }

        :global(.commentaryHead) {
            font-family: "Ysabeau", serif;
            font-size: 1rem;
            margin-bottom: 0;
        }
    }
</style>
